import React from "react";
import { NavLink } from "react-router-dom";

function Visi() {
    return (
        <>
            <section className="section bg-features bg-light" id="features">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-heading mb-5">
                                <h3 className="text-dark mb-1 fw-light text-uppercase">
                                    Visi & Misi
                                </h3>
                                <div className="title-border-simple position-relative"></div>
                            </div>
                        </div>
                    </div>
                    <div className="align-items-center row">
                        <div className="col-lg-6">
                            <div className="features-content">
                                <div className="features-icon">
                                    <i className="pe-7s-science text-primary"></i>
                                </div>
                                <h4 className="fw-normal text-dark mb-3 mt-4">
                                    Visi dan Misi Kami
                                </h4>

                                <p className="text-muted f-14">
                                    Menjadi perpustakaan yang membudayakan
                                    masyarakat gemar membaca serta memperkaya
                                    wawasan masyarakat melalui buku.
                                </p>
                                <ul className="text-muted f-14">
                                    <li>Menyediakan buku-buku bermutu</li>
                                    <li>
                                        Sebagai wadah dari ide-ide kreatif dari
                                        masyarakat
                                    </li>
                                    <li>
                                        Merealisasikan ide-ide kreatif dari
                                        masyarakat
                                    </li>
                                    <li>
                                        Menjadikan masyarakat yang berkualitas,
                                        dari segi pendidikan, budaya dan ekonomi
                                    </li>
                                    <li>
                                        Menjadi forum silaturahmi yang
                                        menjembatani terlaksananya
                                        kegiatan-kegiatan positif yang sifatnya
                                        mengembangkan diri
                                    </li>
                                </ul>
                                <p className="mb-0 text-uppercase f-13">
                                    <NavLink
                                        className="text-primary"
                                        to="/About"
                                    >
                                        learn more
                                        <span className="right-arrow ms-1">
                                            ⇾
                                        </span>
                                    </NavLink>
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="features-img mt-32">
                                <img
                                    src="	https://themes.themesbrand.com/zooki/react/static/media/img-1.1bb1c555fb21d91778ad.png"
                                    alt=""
                                    className="img-fluid mx-auto d-block"
                                ></img>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Visi;
